<template>
  <al-footer :hidden="isLoading">
    <a
      v-if="!basic"
      v-analytics:click="$EVENTS.TERMS_BUTTON"
      :href="termsUrl"
      target="_blank"
      class="btn btn--footer uppercase"
      data-test="terms-button"
      :aria-label="$t('footer.terms')"
      >{{ $t('footer.terms') }}</a
    >
    <a
      v-if="!hidePrivacy"
      v-analytics:click="$EVENTS.COPYRIGHT_BUTTON"
      :href="privacyUrl"
      target="_blank"
      class="btn btn--footer uppercase"
      data-test="privacy-button"
      :aria-label="$t('footer.privacy')"
      >{{ $t('footer.privacy') }}</a
    >
    <a
      v-if="!basic"
      v-analytics:click="$EVENTS.COOKIE_CONSENT_BUTTON"
      href="#"
      tabindex="0"
      class="btn btn--footer uppercase"
      data-test="onetrust-button"
      :aria-label="$t('footer.adChoices')"
      @click="launchOneTrust"
      >{{ $t('footer.adChoices') }}</a
    >
    <feedback-link
      v-if="!basic && !isFeedbackDisabled"
      :client-id="clientId"
      :src-correlation-id="srcCorrelationId"
      :label="$t('footer.feedback')"
      :aria-label="$t('footer.feedback')"
      class="btn btn--footer uppercase"
      data-test="feedback" />
  </al-footer>
</template>

<script>
import { AlFooter } from '@mc-alberta/alcapone'
import FeedbackLink from '@mc-alberta/feedback'
import { mapGetters, mapState } from 'vuex'
import { CLIENT_ID, COUNTRY_FEATURES } from '@/constants'

export default {
  name: 'PageFooter',
  components: { AlFooter, FeedbackLink },
  props: {
    /**
     * Hide all non-privacy links
     */
    basic: {
      type: Boolean,
      default: false
    },
    hidePrivacy: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    clientId: CLIENT_ID,
    isFeedbackDisabled: false
  }),
  computed: {
    ...mapGetters(['isLoading', 'termsUrl', 'privacyUrl']),
    ...mapState({
      countryCode: (state) => state.user.consumer.countryCode,
      srcCorrelationId: (state) => state.correlationId
    })
  },
  watch: {
    countryCode: {
      immediate: true,
      handler() {
        this.isFeedbackDisabled = this.$switchboard.isCountryFeatureEnabled(
          COUNTRY_FEATURES.DISABLE_FEEDBACK
        )
      }
    }
  },
  methods: {
    launchOneTrust() {
      window.Optanon.ToggleInfoDisplay()
    }
  }
}
</script>
